export function shouldSubmitComposerKey(event) {
    return event.key === 'Enter'
        && !event.shiftKey
        && event.ctrlKey !== true
        && event.metaKey !== true
        && event.altKey !== true
        && event.isComposing !== true;
}
//# sourceMappingURL=composerKeys.js.map